import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Switch from "@material-ui/core/Switch";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import Debounce from "@saleor/components/Debounce";
import Skeleton from "@saleor/components/Skeleton";
import { ProductDetails_product_productType_variantAttributes } from "@saleor/products/types/ProductDetails";
import { isSelected } from "@saleor/utils/lists";
import React, { useEffect } from "react";

import { ProductVariantCreateFormData } from "./form";

export interface ProductVariantCreatorValuesProps {
  attributes: ProductDetails_product_productType_variantAttributes[];
  data: ProductVariantCreateFormData;
  onValueClick: (attributeId: string, valueId: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    hideCard: {
      "& .MuiCardContent-root": {
        opacity: ".4",
        pointerEvents: "none"
      }
    },
    valueContainer: {
      display: "grid",
      gridColumnGap: theme.spacing(3),
      gridTemplateColumns: "repeat(5, 1fr)"
    }
  }),
  { name: "ProductVariantCreatorValues" }
);

const ProductVariantCreatorValues: React.FC<ProductVariantCreatorValuesProps> = props => {
  const { attributes, data, onValueClick } = props;
  const classes = useStyles(props);
  const [stateValues, setStateValues] = React.useState<string[]>([]);

  const handleAttributeChange = id => {
    if (!stateValues.includes(id)) {
      setStateValues(prevStateValues => [...prevStateValues, id]);
    } else {
      setStateValues(prevStateValues =>
        prevStateValues.filter(val => val !== id)
      );
    }
  };

  useEffect(() => {
    const attribSelected = data.attributes.filter(
      attrib => attrib.values.length > 0
    );

    if (attribSelected.length > 0) {
      const ids = attribSelected.map(item => item.id);
      setStateValues(prevStateValues => [...prevStateValues, ...ids]);
    }
  }, []);

  return (
    <>
      {attributes.map(attribute => (
        <React.Fragment key={attribute.id}>
          <Card
            className={
              stateValues.includes(attribute.id) ? "" : classes.hideCard
            }
          >
            <CardTitle
              title={attribute?.name || <Skeleton />}
              toolbar={
                <FormControlLabel
                  control={
                    <Switch
                      name={attribute.id}
                      checked={
                        stateValues.includes(attribute.id) ? true : false
                      }
                      onChange={() => handleAttributeChange(attribute.id)}
                      color="primary"
                    />
                  }
                  label="Use this attribute?"
                />
              }
            />
            <CardContent className={classes.valueContainer}>
              {attribute.values.map(value => (
                <Debounce
                  debounceFn={() => onValueClick(attribute.id, value.slug)}
                  time={100}
                  key={value.slug}
                >
                  {change => (
                    <ControlledCheckbox
                      checked={isSelected(
                        value.slug,
                        data.attributes.find(
                          dataAttribute => attribute.id === dataAttribute.id
                        )?.values || [],
                        (a, b) => a === b
                      )}
                      name={`value:${value.slug}`}
                      label={value.name}
                      onChange={change}
                    />
                  )}
                </Debounce>
              ))}
            </CardContent>
          </Card>
          <CardSpacer />
        </React.Fragment>
      ))}
    </>
  );
};

ProductVariantCreatorValues.displayName = "ProductVariantCreatorValues";
export default ProductVariantCreatorValues;
